import request from '@/common/api/request'
import qs from 'qs'

// 获取企业标签2
export function showDictLabel(params) {
  return request.get('/lishui-gov/dictLabel/getAllDictLabel', { params })
}

// 报错时新增
// 获取企业标签
export function queryRecordListDetail(params) {
  return request.get('/lishui-gov/entFileLabel/queryRecordListDetail', { params })
}

// 获取企业标签
export function queryRecordList(params) {
  return request.get('/lishui-gov//entFileLabel/queryRecordList', { params })
}

// 获取标签对应的企业
export function getEntList(params) {
  return request.get('/lishui-gov/dictLabel/getLabel', { params })
}

// 获取精准添加的全部企业
// export function getEntData(params) {
//   return request.get('/lishui-gov/dictLabel/getEntDataAll', { params })
// }
// export function getEntData(params) {
//   return request.get('/lishui-gov/dictLabel/getEntByKey', { params })
// }
export function getEntData(params) {
  return request.get('/lishui-gov/dictLabel/findEntByLike', { params })
}

// 新增文件夹、标签
export function addDictLabel(params) {
  return request.post('/lishui-gov/dictLabel/addDictLabel', qs.stringify(params))
}

// 编辑文件夹、标签
export function updateDictLabel(params) {
  return request.post('/lishui-gov/dictLabel/updateDictLabel', qs.stringify(params))
}

// 删除文件夹、标签
export function deleteDictLabel(params) {
  return request.post('/lishui-gov/dictLabel/deleteDictLabel', qs.stringify(params))
}

// 移动字标签至某个文件夹下
export function moveDictLabel(params) {
  return request.post('/lishui-gov/dictLabel/moveDictLabel', qs.stringify(params))
}

// 模板下载
export function downloadModel(params) {
  return request.downLoad('/lishui-gov/dictLabel/downloadModel', params)
}

// 精准添加
export function insertEnt(params) {
  return request.post('/lishui-gov/dictLabel/insertEnt', qs.stringify(params))
}

// 数据导出
export function downloadEntLabel(params) {
  return request.downLoad('/lishui-gov/dictLabel/downloadEntLabel', params)
}

// 移除企业
export function deleteEntLable(params) {
  return request.get('/lishui-gov/dictLabel/deleteEntLable', { params })
}

// 清空标签下所有企业
export function deleteEntLableForAll(params) {
  return request.get('/lishui-gov/dictLabel/deleteEntLableForAll', { params })
}

// 获取文件上传列表
export function getLableUpHistoryList(params) {
  return request.get('/lishui-gov/dictLabel/getLableUpHistoryList', { params })
}

// 上传文件
// export function importIndustryLabel(params) {
//   return request.upload(process.env.VUE_APP_BASE_API + '/ldmjgovcloud/dictLabel/importIndustryLabel',  params )
// }
export const importIndustryLabel = process.env.VUE_APP_BASE_API + '/lishui-gov/dictLabel/importIndustryLabel'

// 获取上传失败列表
export function getLabelFailList(params) {
  return request.get('/lishui-gov/dictLabel/getLabelFailList', { params })
}
